(function () {
  function init() {
    document.querySelectorAll('[data-holiday-message]').forEach(function (widget) {
      if (widget.dataset.bound) return;
      var root = widget.closest('[data-section-type="product"]') || widget.closest('[data-hc-product]');
      if (!root) return;
      function bind() {
        var field = root.querySelector('textarea[name="properties[Message]"]');
        if (!field || widget.dataset.bound) return;
        var group = field.closest('.form-group') || field.closest('[data-holiday-fields]');
        if (!group) return;
        var label = group.querySelector('label[for="' + field.id + '"]') || group.querySelector('label');
        if (!label) return;
        widget.dataset.bound = 'true';
        group.insertBefore(widget, label);
        var select = widget.querySelector('[data-holiday-message-choice]');
        var display = widget.querySelector('[data-holiday-selected-message]');
        var custom = field.value;
        field.placeholder = widget.dataset.customPlaceholder;
        label.textContent = widget.dataset.customLabel;
        function sync() {
          var own = select.selectedIndex === 0;
          field.hidden = !own; label.hidden = !own; display.hidden = own;
          var value = own ? custom : select.selectedOptions[0].dataset.message;
          Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, value);
          display.textContent = own ? '' : value;
          field.dispatchEvent(new Event('input', {bubbles:true}));
          field.dispatchEvent(new Event('change', {bubbles:true}));
        }
        field.addEventListener('input', function () { if (select.selectedIndex === 0) custom = field.value; });
        select.addEventListener('change', sync); sync();
      }
      bind();
      var observer = new MutationObserver(function () { bind(); if (widget.dataset.bound) observer.disconnect(); });
      if (!widget.dataset.bound) observer.observe(root, {childList:true,subtree:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
